import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import { roomGalleryImages } from "../../util/galleryImages";

// Shared Redux→props mapping used by both room-rental and venue
// BookingOverview wrappers. Each flow then passes the result into its own
// BookingSummary (the two summaries diverge in pricing/voucher logic, so
// they remain separate components).
export const useApartmentSummaryBaseProps = () => {
  const apartmentDetails = useSelector(
    (state: RootState) => state.apartment.apartmentDetails
  );
  const numberOfGuests = useSelector(
    (state: RootState) => state.apartment.numberOfGuest
  );

  // Array.isArray, not ?? [] — pricing_discounts arrives as {} (truthy)
  // for assets migrated without discounts (#1422/#1424/#1440 artifact),
  // which would bypass a nullish fallback.
  const maybeDiscounts = apartmentDetails?.pricingDiscounts;
  const rawPricingDiscounts = Array.isArray(maybeDiscounts)
    ? maybeDiscounts
    : [];

  return {
    // First gallery image — falls back to the featured image, so a room
    // whose only photo is its featured image still gets a thumbnail.
    roomImage: roomGalleryImages(apartmentDetails)[0] ?? "",
    roomTitle: apartmentDetails?.name ?? "",
    address: apartmentDetails?.Group.location.address?.street ?? "",
    pricePerNight:
      apartmentDetails?.Group.pricecategory?.pricescale.find(
        (item: any) => item.durationInMinutes === 1440
      )?.price ?? 0,
    dates: { start: "Feb 08", end: "Feb 10" },
    numberOfGuests: numberOfGuests ?? 1,
    additionalServices: apartmentDetails?.assetAdditionalServices ?? [],
    pricingDiscounts: rawPricingDiscounts,
  };
};
